// components/connexion/contenusEcrans.js
// ============================================================================
// ÉCRANS D'ACCUEIL ET D'AU REVOIR — CE QUE KLASYS AFFICHE
// ============================================================================
//
// Les textes et les horaires arrivent avec les contenus de la page de connexion
// (rubrique `ecrans` de `GET /api/public/page-connexion`), déjà gardés dans le
// navigateur par cette page. Les écrans lisent cette copie, sans appel :
//
//   * l'accueil s'affiche juste après la connexion, la copie est fraîche ;
//   * l'au revoir dure 2,5 secondes — un appel n'aurait pas le temps d'aboutir,
//     et un texte qui change en cours d'écran serait pire que l'ancien texte.
//
// Pas de copie, ou une copie d'avant cette rubrique : les textes du code.
// ============================================================================

import { lireCache } from './contenusConnexion';
import { fusionnerEcrans } from './ecransPassage';

export * from './ecransPassage';

/** Textes et horaires des écrans, fusionnés avec les valeurs du code. */
export const lireEcrans = () => fusionnerEcrans(lireCache()?.config?.ecrans);

// Le site principal et le poste de développement affichent la démonstration
const SITES_DEMO = ['www', 'klasys', 'gestion_scolaire', 'unknown'];

/** Le nom de l'école : celui réglé dans le CIK, à défaut celui du compte. */
export function nomEcoleDe(user) {
  const subdomain = user?.tenant_subdomain;
  if (SITES_DEMO.includes(subdomain)) return 'KLASYS SITE DEMO';
  return lireCache()?.ecole?.nom || user?.tenant_name || (subdomain ? subdomain.toUpperCase() : '');
}
